import React from 'react';
import { getSessionSeriesName } from '../../utils/sessionSeries';

const SessionSeriesBadge = ({ session, name, className = '' }) => {
  const label = name || getSessionSeriesName(session);
  if (!label) return null;

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md border border-primary/25 bg-primary/5 px-2 py-0.5 text-xs font-medium text-primary ${className}`}
      title={`Standing series: ${label}`}
    >
      <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.75}
          d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
        />
      </svg>
      {label}
    </span>
  );
};

export default SessionSeriesBadge;
